import Vue from 'vue'
import Router from 'vue-router'
import AppIndex from '../components/pages'
import pageRouters from './pageRouters'
import scrollBehavior from './scrollBehavior'

Vue.use(Router)

const routes = [
  {
    path: '',
    component: AppIndex,
    redirect: 'homeIndex',
    children: [
      ...pageRouters
    ]
  }
]

const router = new Router({
  routes: routes,
  scrollBehavior
})

router.beforeEach((to, from, next) => {
  if (!to.matched || to.matched.length === 0) {
    next('/')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js